<div class="option-text">{{CustomerSpecificationType.Name}} </div>

<div class="edit-button">
    <button
        app-round-button
        matTooltip="Bearbeiten"
        matTooltipPosition="left"
        (click)="$event.stopPropagation(); onEditClick(CustomerSpecificationType)"
        [Disabled]="isButtonDisabled"
    >
    <fa-icon icon="pencil-alt"></fa-icon>
    </button>
</div>
